import { getLangSwitchList } from '@umu/umu-lang-switch';
import './LanguageSwitch.scss';
import React, { useEffect, useRef } from 'react';
import { useContext, useState, useMemo } from 'react';
import { AppContext } from '../../context/appContext';
import { setSiteLang } from '../../services/langService';
import langIcon from './images/language.png';
import rightIcon from '../../images/arrow-right.png';

interface ILanguageSwitchProps {
    loginCardRef?: React.RefObject<HTMLDivElement>;
}

export const LanguageSwitch = React.memo((props: ILanguageSwitchProps) => {
    const { loginCardRef } = props;
    const { state } = useContext(AppContext);
    const [unfold, setUnfold] = useState(false);
    const options = getLangSwitchList();
    const currentSwitchRef = useRef<HTMLDivElement>(null);

    const onClick = () => {
        setUnfold(!unfold);
    };

    useEffect(() => {
        // 在点击语言切换时，滚动到当前语言选项
        if (!unfold) {
            return;
        }
        if (!currentSwitchRef?.current || !loginCardRef?.current) {
            return;
        }
        loginCardRef.current?.scrollTo({
            top: currentSwitchRef.current.offsetTop,
            behavior: 'smooth',
        });
    }, [unfold]);

    const onLanguageChange = (value: string) => {
        // 把 lang cookie 挂到一级域名上，而不是其它级域名上
        const domain = (window as any)?.pageData?.config?.site_host || location.hostname;
        setSiteLang(value, domain).then(() => {
            window.location.reload();
        });
    };

    const currentLang = useMemo(() => {
        const currentObj = options.find((item) => item.key === state.lang);
        return currentObj === undefined ? false : currentObj.value;
    }, [state.lang]);

    return (
        <div className="language-switch-wrap" ref={currentSwitchRef}>
            <div className="current-language" onClick={onClick}>
                <img className="lang-icon" src={langIcon} alt="lang-icon" />
                <span className="lang-text">{currentLang}</span>
                <img className={`lang-arrow ${unfold ? 'arrow-down' : ''}`} src={rightIcon} alt="right-arrow-icon" />
            </div>
            {unfold && (
                <div className="dropdown-menu">
                    {options.map((item) => (
                        <div
                            key={item.key}
                            className="language-option"
                            onClick={() => {
                                onLanguageChange(item.key);
                            }}
                        >
                            {item.value}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
});
